const PREDEFINED_STEPS = [0.001, 0.002, 0.005, 0.01, 0.02, 0.025, 0.03, 0.04];
const NUM_TICKS = 3;
const NUM_MINOR_TICKS = 5;

export function getChartStep(absMax: number) {
  const step = absMax / NUM_TICKS;
  // round step to the nearest multiple of 5%;
  if (absMax >= 0.1) {
    return Math.ceil(step / 0.05) * 0.05;
  }
  // otherwise use a predefined step if possible
  const predefinedStep = PREDEFINED_STEPS.find((s) => s >= step);
  if (predefinedStep) {
    return predefinedStep;
  }
  return step;
}

export function getChartAbsMax(absMax: number): number {
  // the chart shows 3.5 steps in either direction
  const step = getChartStep(absMax);
  return step * 3.5;
}

export function getChartTicks(absMax: number) {
  const chartAbsMax = getChartAbsMax(absMax);
  const chartStep = getChartStep(absMax);
  const ticks = [];

  const range = Math.floor((NUM_TICKS + 0.5) * NUM_MINOR_TICKS);

  for (let i = -range; i <= range; i++) {
    const tickValue = i / NUM_MINOR_TICKS;
    const value = chartStep * tickValue;
    ticks.push({
      left: `${(50 * (chartAbsMax + value)) / chartAbsMax}%`,
      value: i % NUM_MINOR_TICKS === 0 ? value : undefined,
      minor: i % NUM_MINOR_TICKS !== 0,
      zero: i === 0,
    });
  }

  return ticks;
}
